export default __webpack_public_path__ + "static/media/sports_prize_giving.c5be7253.jpg";